import moment from "moment";
import {
  AGENT_DOWNLOAD_REQUEST_BEGIN,
  AGENT_DOWNLOAD_REQUEST_SUCCESS,
  AGENT_DOWNLOAD_REQUEST_FAILURE
} from "./types";
import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";
import { checkAMLob } from "utils/checkAMLob";


export const agentDownloadRequest = () => async (dispatch, getState) => {
  dispatch({ type: AGENT_DOWNLOAD_REQUEST_BEGIN });
  
  const checkboxInformation = getState().downloadInputInformation.downloadCategories;

  let groupId = "";
  
  for (let item of checkboxInformation) {
    if (item.checked) {
      if (groupId.length) {
        groupId += `~${item.category_id}`;
      } else {
        groupId += item.category_id;
      }
    }
  }
  const isNotWireless = checkAMLob() === "ott" || checkAMLob() === "nico" || checkAMLob() === "vils";
  const custDate =  getState().downloadAmount.downloadAmount
  try {
    const response = await API({
      url: ENDPOINTS.AGENT_DOWNLOAD_REQUEST,
      method: "POST",
      data: {
        identifier: "mtn",
        categoryKeys: isNotWireless ? "all" : groupId,
        value: getState().agentSelectedCustomer.mtn,
        dateRange:  custDate === "1825" ? "Custom" : getState().downloadAmount.downloadAmount,  // using custDate for Last 5 years option
        downloadType: isNotWireless ? "AFFIDAVIT" : getState().downloadInputInformation.sensitivitySelection,
        formatType: getState().downloadInputInformation.fileFormat,
        isCustomDateRange: getState().downloadAmount.downloadAmount.toLowerCase() === "custom" || getState().downloadAmount.downloadAmount.toLowerCase() === "1825" ? "y" : "n",  // Last 5 years option
        startDate: custDate === "1825" ? moment().subtract(custDate, 'days').format('YYYY-MM-DD') : moment(getState().downloadAmount.startDate).format("YYYY-MM-DD"), // Last 5 years option
        endDate: moment(getState().downloadAmount.endDate).format("YYYY-MM-DD")
      }
    });

    if (response && response.status === "OK") {
      dispatch({
        type: AGENT_DOWNLOAD_REQUEST_SUCCESS,
        payload: response.data
      });
    } else {
      dispatch({ type: AGENT_DOWNLOAD_REQUEST_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    if (error.response && error.response.hasOwnProperty("description")) {
      dispatch({
        type: AGENT_DOWNLOAD_REQUEST_FAILURE,
        payload: error.response.description
      });
    } else {
      dispatch({
        type: AGENT_DOWNLOAD_REQUEST_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  }
};
